































































































import  Loading from 'vue-loading-overlay';
import { AuthStoreHelper, NotificationStoreHelper, RootStoreHelper, VehicleCompanyStoreHelper } from '../../core/mixins';
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    PlayBackInfo,
    PlaybackState,
    mapFromRangeToRange,
    getDateFromDateFormatApi,
    getStringTimeFromDate,
    sortObjectByPropertyName,
    TypeVehicleState,
    getStateByNumber,
    removeAccentsFromString,
    addTimeToDate,
    getNowNoFormat,
    formatDate,
    watchClass,
    getMomentPlusTime,
    tableSort,
    downloadJsonData,
    getActualTimestamp,
    getIdsFromList,
    activeFormatter,
    nullOrEmptyFormatter,
    isNullOrEmpty,
    getIndexFromList,
    EventBus,
    TypeEventBus,
    getUniqueId,
    getDateTimeToYesterday,
    getDateTimeFromYesterday,
    getDateTimeFromToDay,
    getDateTimeToToDay,
    getParameterFromUrl
} from '../../core/utils';
import CardPlayBackInfo from './CardPlayBackInfo.vue';
import { dateTypes, diffOptions, TypeFilterDate, UserCustomization } from '../../core/models';
import { TrackingService, UserService } from '../../core/api';
import { getVehiclePlateFromVehicleId, getVehicleVinById }from '../../core/mixins/';
import { Destroyed } from '../../core/decorators';
import { centerVehicleInMap, VariablesTypes } from '../utils';
import { getRowBasedOnVisibleHeadersAndUserSearch, getVehicleStateByNumberAsText } from '../../core/utils/table-utils';
import FleetSummaryUserSettings from './FleetSummaryUserSettings.vue';
import multiselect from 'vue-multiselect';
import rowItem from './Table/rowItem.vue';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import Button from '../../core/components/Button.vue'; 
import VehicleChooserForCurrentCompany from '../../vehicles/components/VehicleChooserForCurrentCompany.vue'; 
import Combobox from '../../core/components/Combobox.vue'; 
import ExportExcelButton from '../../core/components/ExportExcelButton.vue'; 
import { parseSpeedValue } from '../../core/components/Map';
import { LastReportDtcItem, VehicleDtcsInfo, LastReportDtcsResponse, LastReportTableItem, HistoricalDtcsResponse } from '../api/LastReportDtcs';
import Axios, { CancelTokenSource } from 'axios';
import { ActivesOptions } from '../../../features/insurance/options';
import { activesDtcsStatus } from '../../reempujon/helpers';
@Component({
    components: { 
        FleetSummaryUserSettings,
        Loading,
        rowItem,
        multiselect,
        Input,
        SimpleTable,
        Button,
        ExportExcelButton,
        Combobox,
        VehicleChooserForCurrentCompany
     }
})
export default class DtcsFailuresTable extends Mixins(
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper
) {
   @Prop({default: 50}) getItemsPerPage: number;
   @Prop({default: false}) shouldDisplayActualStateTable: boolean;
   @Prop({default: 390}) getActualStateTableHeight: number;
   @Prop({default: ''}) statsPanelTabClicked: string;
   @Prop({default: false}) expandedPanel: boolean;

   requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
   itemsDtcs: Array<LastReportTableItem> = [];
   filteredRowsByUser:Array<object> = [];
   selectedVehicle: null | string = null;
   downloadingItems: boolean = false;
   searchTable: string = '';
   searchTableDebounce: string = '';
   noItemsToDownloadText: string = 'No hay filas para descargar';
   downloadItemsText: string = 'Descargar tabla';
   debounce: any = null;
   sortBy: string[] = [''];
   sortDesc: boolean[] = [false];
   pendingDtcs: boolean = false;
   activeOptions: Array<object> = ActivesOptions;
   selectedVehicleResetValue: boolean = false;
   headersTable: Array<object> = [
        {
            text: 'Vehículo',
            align: 'left',
            value: 'vehicle_description',
            filter: this.filterByVehicle
        },
        {
            text: 'Módulo',
            align: 'center',
            value: 'ecu_public_description'
        },
        {
            text: 'Código de falla',
            align: 'center',
            value: 'dtc',
            formatter: (value) => {
                if(isNullOrEmpty(value)){
                    return nullOrEmptyFormatter(value)
                }
                return value
            },
        },
        {
            text: 'Descripción',
            align: 'center',
            value: 'description'
        },
        {
            text: 'Estado',
            align: 'left',
            value: 'status',
            formatter: (value) => {
                if(isNullOrEmpty(value)){
                    return nullOrEmptyFormatter(value)
                }
                return activesDtcsStatus[value]
            },
            filter: this.filterByStatus
        },
        {
            text: 'Clasificación',
            align: 'center',
            value: 'classification',
        },
        {
            text: 'Fecha',
            align: 'center',
            value: 'timestamp',
            formatter: (value) => {
                return formatDate(value, true)
            }
        },
   ];
    statusProperties:object = {};

    preselectVehicleInSelector(){
        //si hay un solo vehiculo seleccionado, lo preselecciono en el selector
        if(this.$_getSelectedVehiclesByID.length == 1){
            let vehicleId = this.$_getSelectedVehiclesByID[0];
            let vehicleIndex = getIndexFromList(this.getVehiclesList, 'id', vehicleId);
            if(vehicleIndex !== -1){
                this.updateSelectedVehicle(this.$_getVehiclesFromSelectedCompany[vehicleIndex])
            }
        }else{
            this.updateSelectedVehicle(null)
        }
    }


   get getVehiclesList(){
    return this.$_getVehiclesFromSelectedCompany
   }

   @Watch('$_getFilterDate')
    observableFilterDate(){
     this.itemsDtcs = [];
    }

    cancelPreviousRequest(){
        if(this.requestTokenInstance){
            this.requestTokenInstance.cancel();
        }
    }

   get currentFilter(){
    return TypeFilterDate.TODAY
   }

    updateSelectedVehicle(value){
     this.selectedVehicle = value;
    }

   filterByStatus(value) {
        if(this.activeSelected == null){
            return true
        }
        return value == this.activeSelected['id'];
    }
   
   activeSelected: object | null = null;
   activeResetValue: boolean = false;
   updateActiveSelected(value){
    this.activeSelected = value;
   }
    updateActiveResetValue(value){
     this.activeResetValue = value;
    }

   get getExcelFileName(){
    let name = 'dtcs_empresa_';
    if(this.$_getSelectedCompany){
        name += this.$_getSelectedCompany['name']
    }
    return name
   }

   clearVehicleSelected(){
    this.selectedVehicle = null;
   }


   @Emit()
   showVehicleInMap(positions){return positions}


   customFilterForFleetSummary(items, userSearch, currentRow):boolean {
    return getRowBasedOnVisibleHeadersAndUserSearch(userSearch, currentRow, this.headersTable)
   }


   @Watch('$_getSelectedVehiclesByID')
   observableSelectedVehicles(){
    this.searchTable = '';
    this.searchTableDebounce = '';
    this.getDtcsInfo()
    this.preselectVehicleInSelector();
   }

   updateFilteredItemsFleetSummary(items){
    this.filteredRowsByUser = items;
   }

   filterByVehicle(value) {
        return this.selectedVehicle == null ? true : value === this.selectedVehicle['description'];
   }

    filterSearch(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableDebounce = value;
        }, 600);
    }


    viewVehicleInMap(item: LastReportTableItem){
        EventBus.$emit(TypeEventBus.VIEW_VEHICLE_IN_MAP_FROM_DTC_FAILS, item.vehicle_id)
    }

     customSortForFleetSummary(items: object[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc)
    }

    getMomentParsedTime(time) {
        return getMomentPlusTime(time)
    }

    mounted(){
        this.preselectVehicleInSelector()
    }

    getTimeDiff(value, type: diffOptions){
        return addTimeToDate(getNowNoFormat(), value, type)  
    }


     getParseTime(time) {
        if (!time.match(/(\d+)/))
            return {
                measure: null,
                value: null
            };
        let timeValue = time.match(/(\d+)/)[0];
        let timeMeasure = time.substring(time.indexOf(' ') + 1);
        return {
            measure: timeMeasure,
            value: timeValue
        };
    }


    created(){
        this.getDtcsInfo()
    }

    getDtcsItemsToTableFormat(response: LastReportDtcsResponse | HistoricalDtcsResponse): Array<LastReportTableItem>{
        let tableItems: Array<LastReportTableItem> = [];
        if(response.length > 0){
            for (let index = 0; index < response.length; index++) {
                let vehicleInfo:VehicleDtcsInfo = response[index];

                //recorro los dtcs de cada vehiculo y agrego una fila a tableItems por cada uno
                for (let index = 0; index < vehicleInfo.dtcs.length; index++) {
                    let dtcInfo: LastReportDtcItem = vehicleInfo.dtcs[index];
                    
                    let tableItem: LastReportTableItem = {
                        vehicle_description: vehicleInfo.vehicle_description,
                        ecu_public_description: nullOrEmptyFormatter(dtcInfo.ecu_public_description),
                        dtc: dtcInfo.dtc,
                        description: nullOrEmptyFormatter(dtcInfo.description),
                        status: dtcInfo.status,
                        id: getUniqueId(),
                        vehicle_id: vehicleInfo.vehicle_id,
                        classification: this.getClassificationParsed(dtcInfo.classification),
                        timestamp: nullOrEmptyFormatter(dtcInfo.timestamp),
                    }
                    tableItems.push(tableItem)
                }
            }
        }

        return tableItems
    }

    getClassificationParsed(classification: number): string{
        let classificationValue = '-';
        if(!isNullOrEmpty(classification)){
            let classificationChoices = this.$_getNormsProperties['all_dtc_classifications'];
            let classificationIndex = getIndexFromList(classificationChoices, 'id', classification);

            if(classificationIndex !== -1){
                classificationValue = classificationChoices[classificationIndex]['description']
            }
        }
        return classificationValue
    }

    get currentFilterIsNow(){
        return this.$_getFilterDate === TypeFilterDate.TR 
    }

    get getTableHeight(){
        let height = this.getActualStateTableHeight;
        if(!this.currentFilterIsNow && !this.expandedPanel){
            height = 300
        }
        return height
    }


    getDtcsInfo(){
        if(this.pendingDtcs){
            return
        }

        this.cancelPreviousRequest();
        this.requestTokenInstance = Axios.CancelToken.source();
        let selectedVehiclesIds = this.$_getSelectedVehiclesByID;
        let allVehiclesIds = getIdsFromList(this.$_getVehiclesFromSelectedCompany); 
        let vehiclesQuery = selectedVehiclesIds.length > 0 ? selectedVehiclesIds : allVehiclesIds;
        this.pendingDtcs = true;
        this.itemsDtcs = [];

        if(this.currentFilterIsNow){
            this.getLastReportInfo(vehiclesQuery)
        }else{
            this.getHistoricalDtcs(vehiclesQuery)
        }
    }

    get getDtcsTableItems(){
        let filteredIds = this.$_getFilteredLastReportVehicles;

        return  this.itemsDtcs.filter(
            item => filteredIds.includes(item['vehicle_id'])
        ).map(item => item)
    }

    getLastReportInfo(vehiclesQuery){
         TrackingService.getLastReportDtcs(
            this.requestTokenInstance,
            vehiclesQuery
        )
        .then((response: LastReportDtcsResponse) => {
            this.itemsDtcs = this.getDtcsItemsToTableFormat(response);
        }).catch((error) => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudieron obtener los dtcs'
            });
        }).finally(() => {
            this.pendingDtcs = false;
        })
    }

    getHistoricalDtcs(vehiclesQuery){
        let params = {
            datetime_from: '',
            datetime_to: '',
        }
        if (this.$_getFilterDate == TypeFilterDate.TODAY) {
            params.datetime_from = getDateTimeFromToDay();
            params.datetime_to = getDateTimeToToDay();
        } else if (this.$_getFilterDate == TypeFilterDate.YESTERDAY) {
            params.datetime_from = getDateTimeFromYesterday();
            params.datetime_to = getDateTimeToYesterday();
        } else {
            params.datetime_from = this.$_getDateRange.datetime_from;
            params.datetime_to = this.$_getDateRange.datetime_to;
        }
         TrackingService.getHistoricalDtcs(
            params.datetime_from,
            params.datetime_to,
            this.requestTokenInstance,
            vehiclesQuery
        )
        .then((response: HistoricalDtcsResponse) => {
            this.itemsDtcs = this.getDtcsItemsToTableFormat(response);
            this.assignHistoricalDtcs(response)
        }).catch((error) => {
            this.assignHistoricalDtcs({});
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudieron obtener los dtcs'
            });
        }).finally(() => {
            this.pendingDtcs = false;
        })
    }

    @Emit()
    assignHistoricalDtcs(dtcs){}

}
